import {
  StateNodeConfig,
  BaseActionObject,
  assign,
  DoneInvokeEvent
} from "xstate4"
import { Context, Transitions } from "../../../types"
import {
  getServiceErrorMessage,
  getTimingOptionByValue
} from "../../../helpers"

export const getGlobalSettingsTransition: StateNodeConfig<
  Context,
  {},
  Transitions,
  BaseActionObject
> = {
  invoke: {
    id: "getGlobalSettings",
    src: "getGlobalSettings",
    onDone: {
      target: "idle",
      actions: assign((_ctx, evt) => ({
        resetMasteryLessonsDefault:
          evt.data.studentCanResetMasteryLessonsDefault,
        studyPlansOutOfOrderDefault: evt.data.studentCanDoOutOfOrderDefault,
        studentTestTimingValueDefault: evt.data.studentTestTimingValueDefault,
        studyPlansOutOfOrder: evt.data.studentCanDoOutOfOrder,
        resetMasteryLessons: evt.data.studentCanResetMasteryLessons,
        planSettings: {
          studentCanDoOutOfOrder: evt.data.studentCanDoOutOfOrder,
          studentCanResetMasteryLessons: evt.data.studentCanResetMasteryLessons,
          studentCanPauseTests: evt.data.studentCanPauseTests,
          studentTestTimingValue: evt.data.studentTestTimingValue,
          studentTestTimingType: evt.data.studentTestTimingType,
          timingOption: getTimingOptionByValue(
            evt.data.studentTestTimingValue,
            evt.data.studentTestTimingType
          )
        }
      }))
    },
    onError: {
      target: "idle",
      actions: assign<Context, DoneInvokeEvent<any>>({
        snackbar: (_ctx, _evt) => ({
          message: getServiceErrorMessage("getGlobalSettings", {
            messageData: ["get the study plan"]
          }),
          withUndo: false,
          error: true
        })
      })
    }
  }
}
